export const PRODUCT_NAMES = {
  appearanceProtection: 'Appearance Protection',
  gap: 'GAP',
  leaseWearAndTear: 'Lease Wear And Tear',
  tireAndWheel: 'Tire And Wheel',
  keyRemoteReplacement: 'Key/Remote Replacement',
  paintlessDentRepair: 'Paintless Dent Repair',
  theft: 'Theft',
  serviceWrap: 'Service Wrap (Maintenance Care)',
  valueProtect: 'Value Protect',
  glass: 'Glass',
}
export default { PRODUCT_NAMES };
